import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, ButtonBase, Typography } from '@mui/material';
import React from 'react';
import { AppPageHeader } from '../AppPageHeader';
import { useCommonWebTranslation } from '../hooks';
/**
 * @deprecated Replaced by `GlobalApp`. To control scrolling behavior, use `FullHeightPage`.
 * Do not use together with `GlobalApp` in new code.
 * @param {AppPageHeader2Props} props - Props including the page title, subtitle breadcrumbs, and back navigation handler.
 * @returns {React.ReactElement} The rendered legacy header with title, back button, and breadcrumb support.
 */
export const AppPageHeader2 = (props) => {
    const { t } = useCommonWebTranslation();
    let needButtonMargin = true;
    if (typeof props.subTitle === 'string') {
        needButtonMargin = false;
    }
    if (Array.isArray(props.subTitle) && props.subTitle.length > 0) {
        needButtonMargin = false;
    }
    return (React.createElement(AppPageHeader, null,
        React.createElement(ButtonBase, { focusRipple: true, sx: {
                padding: 1,
                marginRight: needButtonMargin ? 2 : 0,
                color: (theme) => theme.palette.text.secondary,
            }, onClick: props.onBack, "aria-label": t('common.back') + ', ' + props.title },
            React.createElement(ArrowBackIcon, { sx: { marginRight: 2 } }),
            React.createElement(Typography, { variant: 'body1' }, props.title)),
        React.createElement(Box, { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
            typeof props.subTitle === 'string' && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { sx: {
                        marginLeft: 2,
                        marginRight: 3,
                    }, display: 'inline', variant: 'body1' }, "/"),
                React.createElement(Typography, { display: 'inline', variant: 'body1' }, props.subTitle))),
            Array.isArray(props.subTitle) &&
                props.subTitle.map((subTitle, index, array) => (React.createElement(React.Fragment, { key: index },
                    React.createElement(Typography, { sx: {
                            marginLeft: index === 0 ? 2 : 3,
                            marginRight: 3,
                        }, variant: 'body1', component: 'span' }, "/"),
                    typeof subTitle !== 'string' && index < array.length - 1 ? (React.createElement(ButtonBase, { sx: {
                            padding: 1,
                            marginRight: needButtonMargin ? 2 : 0,
                            color: (theme) => theme.palette.text.secondary,
                        }, onClick: subTitle.onClick, "data-test": `breadcrumb-${index}` },
                        React.createElement(Typography, { variant: 'body1' }, subTitle.label))) : (React.createElement(Typography, { sx: {
                            marginRight: index === array.length - 1 ? 2 : 0,
                        }, variant: 'body1', component: 'span', "data-test": `breadcrumb-${index}` }, typeof subTitle === 'string' ? subTitle : subTitle.label))))))));
};
